import { Link, NavLink } from "react-router-dom";
import { Search, ShieldCheck } from "lucide-react";
import logo from "../assets/img/logo.jpeg";

const linkBase = "text-sm font-medium transition-colors";
const linkClass = ({ isActive }) =>
  `${linkBase} ${isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"}`;

// Agregamos { minimal = false } como propiedad
export default function Header({ minimal = false }) {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        
        {/* LOGO: Se muestra siempre */}
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2"
        >
          <img src={logo} alt="Senderos de Providencia" className="h-8 w-auto" />
          <span className="font-display font-bold text-lg tracking-tight">
            Senderos de Providencia
          </span>
        </Link>

        {/* NAVEGACIÓN: Se oculta si 'minimal' es true */}
        {!minimal && (
          <nav className="flex items-center gap-6">
            {/* <NavLink
              to="/"
              end
              className={linkClass}
              data-testid="nav-map"
            >
              Mapa Principal
            </NavLink> */}
            <NavLink
              to="/status"
              className={linkClass}
              data-testid="nav-status"
            >
              <span className="inline-flex items-center gap-1.5">
                <Search size={14} /> Buscar Reserva
              </span>
            </NavLink>
            <NavLink
              to="/admin/login"
              className={linkClass}
              data-testid="nav-admin"
            >
              <span className="inline-flex items-center gap-1.5">
                <ShieldCheck size={14} /> Panel de Administracion
              </span>
            </NavLink>
          </nav>
        )}
        
      </div>
    </header>
  );
}